import { register } from "@rill/loader";
import { whoIsAthleteCoach } from "../utils/user-helpers";

register(
  {
    name: "phasesTemplates",
    meta: ["no-bust", "user"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { coach, athleteId }) => {
    let query = {
      athleteId,
      coach,
    };

    const organizationCoach = locals.query.organizationCoach || undefined;
    const organizationOwnerId = locals.organizationOwner?._id;
    const organizationCoachId = organizationCoach
      ? whoIsAthleteCoach(
          locals.activeUser.athletes,
          athleteId,
          locals.activeUser._id,
          organizationCoach
        )
      : undefined;

    if (organizationCoachId) {
      query = { ...query, organizationCoachId };
    }
    // If there is the organization owner, we need to fetch the templates from the organization owner
    organizationOwnerId && (query = { ...query, organizationOwnerId });

    const res = await api("coach-phase-template", {
      method: "GET",
      query,
    });
    return res.json();
  }
);

// The switch-aware periodization read - phases, weekly attachments/notes and
// events, in the legacy `{ trainingPhases, events }` shape every current GUI
// consumer already expects (AnnualPlanner.js, dateRange.js, planStatus.js,
// phase-templates-modal.js). Whether msb-api answers from `annualPlan` or
// from `periodization-plan`/`periodization-event` is decided entirely
// server-side; this loader never knows which. `meta: ["no-bust", "user"]`
// is safe here because every phase/event mutation route already bumps the
// "user" resource (`updateLastModifiedCoach(ctx, next, "user")`) - the same
// signal the "athlete" and "phasesTemplates" loaders above rely on - so this
// cache gets busted exactly when it would otherwise go stale.
register(
  {
    name: "periodizationData",
    meta: ["no-bust", "user"],
    ttl: "2 hours",
  },
  async ({ api }, { athleteId, organizationCoachId }) => {
    let query = { athleteId };
    if (organizationCoachId) query = { ...query, organizationCoachId };

    const res = await api("athlete-phases", {
      method: "GET",
      query,
    });
    return res.json();
  }
);

register(
  {
    name: "athleteVolumes",
    meta: ["no-bust", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { athleteId, monthFrom, monthTo }) => {
    const res = await api("athlete-volumes", {
      method: "GET",
      query: {
        athleteId,
        monthFrom,
        monthTo,
      },
    });

    const data = await res.json();

    return data.volumes;
  }
);

register(
  {
    name: "athleteStats",
    meta: ["no-bust", "daily-stats"],
    ttl: "2 hours",
  },
  async ({ api }, { athleteId, monthFrom, monthTo }) => {
    const res = await api("athlete-stats", {
      method: "GET",
      query: {
        athleteId,
        monthFrom,
        monthTo,
      },
    });

    const data = await res.json();

    return data.stats;
  }
);
